import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../core/services/api.service';
import { AppFileFolderModel, AppFileModel } from '../models/appfile.model';

@Injectable({
  providedIn: 'root'
})
export class AppfileService {
  constructor(private apiService: ApiService) { }

  addAppFileFolder(folderData: AppFileFolderModel): Observable<number> {
    return this.apiService.post('AppFile/CreateAppFileFolder', folderData);
  }

  getAppFiles(): Observable<AppFileFolderModel[]> {
    return this.apiService.get('AppFile/GetAppFiles');
  }

  getAppFileById(fileId: number): Observable<AppFileModel> {
    return this.apiService.get(`AppFile/GetAppFileById/${fileId}`);
  }

  addAppFile(fileData: any): Observable<any> {
    return this.apiService.post('AppFile/AddAppFile', fileData);
  }

  startAppFileChunkUpload(request: {
    fileName: string;
    fileSize: number;
    fileFolderId?: number | null;
    chunkSize: number;
    totalChunks: number;
  }): Observable<{ uploadId: string; chunkSize: number; totalChunks: number }> {
    return this.apiService.post('AppFile/StartAppFileChunkUpload', request);
  }

  uploadAppFileChunk(uploadId: string, chunkIndex: number, chunk: Blob): Observable<any> {
    const formData = new FormData();
    formData.append('uploadId', uploadId);
    formData.append('chunkIndex', chunkIndex.toString());
    formData.append('chunk', chunk);
    return this.apiService.postWithoutSpinner('AppFile/UploadAppFileChunk', formData);
  }

  completeAppFileChunkUpload(uploadId: string): Observable<any> {
    return this.apiService.post('AppFile/CompleteAppFileChunkUpload', { uploadId });
  }

  updateAppFile(model: AppFileModel): Observable<any> {
    return this.apiService.put('AppFile/UpdateAppFile', model);
  }

  bulkDeleteAppFiles(fileIds: number[], folderIds: number[]): Observable<any> {
    return this.apiService.post('AppFile/BulkDeleteAppFiles', { fileIds, folderIds });
  }

  deleteAppFile(fileId: number): Observable<any> {
    return this.apiService.delete(`AppFile/DeleteAppFile/${fileId}`);
  }

  deleteAppFileFolder(fileFolderId: number): Observable<any> {
    return this.apiService.delete(`AppFile/DeleteAppFileFolder/${fileFolderId}`);
  }

  downloadFolderAsZip(folderId: number): Observable<Blob> {
    return this.apiService.getBlob(`AppFile/DownloadFolderAsZip/${folderId}`);
  }
}
